import React from 'react';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { CurrencyCode } from 'further-types/lp/vehicle';
import TransferFeesContent from './TransferFeesContent';
import { CalendarDay } from 'further-ui/utils';
import { useFormContext } from 'react-hook-form';
import { PartnerTransfersFormValues } from '../../hooks/usePartnerTransfersForm';

const TransferFees: React.FC<{
  partnerTransferId: string;
  baseCurrency: CurrencyCode;
  onNext: () => void;
  onPrevious: () => void;
}> = ({ partnerTransferId, baseCurrency, onNext, onPrevious }) => {
  const { selectedVehicleId } = useLayoutContext();
  const { getValues } = useFormContext<PartnerTransfersFormValues>();

  const [feesData] = api.partnerTransfers.getFees.useSuspenseQuery(
    {
      partnerTransferId,
      vehicleId: selectedVehicleId ?? '',
    },
    {
      staleTime: 0,
      gcTime: 0,
    },
  );

  const transferDate = getValues('transferDate') ?? new CalendarDay(new Date());

  return (
    <TransferFeesContent
      partnerTransferId={partnerTransferId}
      fees={feesData.fees}
      baseCurrency={baseCurrency}
      transferDate={transferDate}
      onNext={onNext}
      onPrevious={onPrevious}
    />
  );
};

export default TransferFees;
